import styled, { css } from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Title = styled.p`
  text-transform: uppercase;
font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 13px;
  font-weight: 900;
  color: ${(props) => props.theme.default.color.primary};
`;

export const CatagoryWrapper = styled.div`
  grid-template-columns: 1fr 1fr 1fr;
  display: grid;
  z-index: 2000;

 font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 1fr;
    width: 100%;
    margin: 0;
    right: 0;
    padding: 20px 0;
    top: 50px;
  }
  a {
    :hover {
      color: ${({ theme }) => theme.default.color.primary};
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .catagory_item{
    font-size: 16px
  }
`;
